module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.index.title')) + " (" + _vm._s(_vm.transfers.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  })], 1), _vm._v(" "), _c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.transfers.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.transfer.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.transfer.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.transfer.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.transfers.items), function(p, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "wide": true
      },
      nativeOn: {
        "click": function($event) {
          return _vm.viewTransfer(p)
        }
      }
    }, [_c('div', {
      staticClass: "full-w flex wrap client-title-container margin-b-10"
    }, [_c('img', {
      staticClass: "client-img margin-b-10",
      attrs: {
        "src": require("./../../../../../assets/images/stock.png"),
        "alt": ("" + (p.code))
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v("TR-" + _vm._s(("" + (p.code))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.type')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.transferTypeName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.fromWarehouse')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(" " + _vm._s(p.fromWarehouseName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.toWarehouse')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(" " + _vm._s(p.toWarehouseName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.createdAt')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(p.createdAt, 'DD-MM-YYYY') || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.status')) + " ")]), _c('span', {
      staticClass: "cardContent capitalize"
    }, [_vm._v(" " + _vm._s(p.status ? p.status : '-'))])], _c('br')], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('v-table', {
    attrs: {
      "list": _vm.transfersListView,
      "noDataMessage": _vm.$t('static.defaultText.transfer.noDataMsg'),
      "link": _vm.viewTransfer,
      "linkKey": "code",
      "rowKey": "id",
      "translation": "static.transfer.info"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.transfers.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e8e4116","hasScoped":true}!./src/app/pages/withNavigation/transfer/index/index.html
// module id = 2912
// module chunks = 1